module.exports = __webpack_public_path__ + "static/img/045_TO8_1551_og.b2ced67.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/045_TO8_1551_og.jpg
// module id = ZQ8s
// module chunks = 0